module.exports = __webpack_public_path__ + "img/workout-notebook_B09HQ4N87F.ca929bec.jpg";